import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Subject, Observable, combineLatest, EMPTY, of } from "rxjs";
import { PandioReviews } from "../model/pandio-reviews";
import {
  ICols,
  IFitersObject,
  IReviewData,
  IReviewsMetrics,
  IReviewsMetricsResponse,
  PeriodText,
  PeriodType,
} from "../review-management.interfaces";
import { PandioReviewsDataService } from "../services/pandio-reviews-data-service";
import { Table } from 'primeng/table';
import { IFilterData, GraphCount } from "src/app/core/feature-modules/table-filter/table-filter.interfaces";
import { SessionService } from "src/app/core/backend-adapter/session.service";
import { SocketService } from "src/app/core/backend-adapter/socket.service";
import { NotifyService } from "src/app/core/layouts/notifications/notify/notify.service";
import { PandioReviewsConfigService } from '../services/pandio-reviews-config-service';
import { ExportDataToFile } from "../services/export-reviews-file.service";
import { DeletePopupComponent } from "../components/delete-popup/delete-popup.component";
import { DialogService } from "primeng/dynamicdialog";
import { FILTER_TYPES  } from 'src/app/core/feature-modules/table-filter/table-filter.interfaces';
import { ReviewsCopyClipboardService } from "../services/reviews-copy-clipboard.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  take,
  takeUntil,
  filter as rxFilter,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  map,
  catchError,
} from "rxjs/operators";
import { IAccount } from "src/app/acct-comps/accounts.interfaces";
import { generateJWTToken } from "src/app/core/helpers/jwt-token.utils";
import { SelectedLocationsStore } from "../../loc-comps/selected-locations.store";
import { SYSTEM_COLORS } from 'src/app/core/feature-modules/whitelabel/style-changer/styles/colors/system-colors.constants';

@Component({
  selector: 'app-pandio-reviews-tab',
  templateUrl: './pandio-reviews-tab.component.html',
  styleUrls: ['./pandio-reviews-tab.component.scss'],
})

export class PandioReviewsTabComponent implements OnInit, OnChanges, OnDestroy {
  SYSTEM_COLORS = SYSTEM_COLORS;
  /** Reviews directory to query; maps to the `reviews/list/<reviewType>` API path segment. */
  @Input() reviewType: string = 'healthgrades';
  @ViewChild('reviewTbl', { static: false }) reviewTbl: Table;
  /** To unsubscribe when component gets destroyed */
  private ngSubscribe$ = new Subject();
  private keywordSearch$ = new Subject<string>();
  private reviewsLoadTrigger$ = new Subject<void>();
  private lastSearchKeyword = '';
  private sortOrder: string = '';
  /** Active client-side sort column applied to the current page of reviews. */
  private activeSortField: string = 'reviewCreatedAt';
  /** Active client-side sort direction: 1 ascending, -1 descending. */
  private activeSortOrder: number = -1;
  /** Review fields whose values are date objects and must be compared by timestamp. */
  private readonly dateSortFields: Set<string> = new Set(['reviewCreatedAt', 'reviewUpdatedAt', 'replyUpdatedAt']);
  /** Store all reviews data */
  private allReviewsData: IReviewData[] = [];
  private offset: number = 0;
  /** To allow user to download all reviews available in the view. */
  private enableSelectAllReviews: boolean = false;
  /** Property to set pandio reviews count */
  public reviewsCountGraphData: PandioReviews;
  /** Options object for horizontal bar graph */
  public options: unknown;
  /** Property to hide/display the accordian/reviews component */
  public displayReviewsCard: boolean = true;
  /** Prop to store pandios reviews data for table */
  public reviewsTableData: IReviewData[] = [];
  /** Table page size */
  public pageSize: number = 50;
  /** Total number of reviews returned by API */
  public totalReviewsCount: number;
  /** Reviews table column's title */
  public cols: ICols[] = [];
  /**To highlight the selected reviews by user in the UI */
  public selectedReviews: IReviewData[] = [];
  /** Set table columns header dynamically */
  public tableColumnsHeader;
  /** Total reviews */
  public totalReviews: string = '';
  /** Filter table by Directories  */
  public filterData: IFilterData[] = [];
  /** Action itmes to download reviews report */
  /** Average ratings for directories. */
  public averageDirectoriesRating = [];
  /** Set graph options for stacked bar graph. */
  public stackedGraphOptions: unknown;
  /** Sentiment reports for Directories porp */
  public sentimentReportsData: PandioReviews;
  public keyword = '';
  public reviewData;
  chipsArray: string[] = [];
  reviewsData: IReviewsMetrics;
  filters: IFitersObject = {};
  // Refactor this later........
  totalReviewsTP: number;
  last30DaysReviewsTP: number;
  public loading: boolean = true;
  public selectAllReviews: boolean = false;
  /** Stores user's search */
  public search: string = '';
  public startDate: string;
  public endDate: string;
  public dateFilterDisplayType: 'custom' | 'preset' = 'preset';
  public dateFilterLabel: string = PeriodText.LAST_30_DAYS;

  private selectedDateRange: string = 'DefaultDate';
  private dateRangeSet = new Set(['This month', 'Last 30 days', 'Last month', 'Year to date', 'Last 12 months']);
  private accountId: number;
  private userId: number;
  private reviewPageTokensByIndex: Record<number, string | null> = { 0: null };
  private periodType: PeriodType;
  public locationFilter: string = '';
  private readonly customDateRangeRegex = /^\d{4}-\d{2}-\d{2} - \d{4}-\d{2}-\d{2}$/;

  private readonly API_TO_QUERY: Record<string, string> = {
    storecode: 'storecode',
    business_names: 'businessname',
    city: 'city',
    states: 'state',
    countries: 'country',
    tag_list: 'tag',
    label_list: 'labels',
    category_list: 'categories',
  };

  constructor(
    private http: HttpClient,
    private pandioReviewsdataService: PandioReviewsDataService,
    public sessionService: SessionService,
    public socketService: SocketService,
    private notifyService: NotifyService,
    private pandioReviewsConfigService: PandioReviewsConfigService,
    private exportDataToFile: ExportDataToFile,
    private dialogService: DialogService,
    private reviewsCopyClipboardService: ReviewsCopyClipboardService,
    private selectedLocationsStore: SelectedLocationsStore
  ) { }

  ngOnInit(): void {
    this.initializeReviewsLoadQueue();
    this.initializeKeywordSearchDebounce();
    this.tableColumnsHeader = this.pandioReviewsConfigService.generateTableHeaderData();
    this.options = this.pandioReviewsConfigService.initReviewsGraph();
    this.cols = this.pandioReviewsConfigService.tableColsHeader;
    this.stackedGraphOptions = this.pandioReviewsConfigService.generateStackedSentimentReportsGraph();
    this.initUserFetchData()
      .pipe(takeUntil(this.ngSubscribe$))
      .subscribe(([account, user]: [IAccount, any]) => {
        this.accountId = account?._id;
        this.userId = user?.login?._id;
        const getQS = () => {
          const qs = this.filtersQSFromStore();
          return qs && qs.length ? qs : 'operand=AND';
        };
        this.locationFilter = getQS();
        this.selectedLocationsStore.state$
          .pipe(takeUntil(this.ngSubscribe$))
          .subscribe(() => {
            this.locationFilter = getQS();
            this.resetReviewsPagination();
            this.loadReviews();
          });
        //this.getAllMetricsData();
        this.loadReviews();
      });

    this.filterData.push(
      {
        type: FILTER_TYPES.MULTI,
        title: 'RATINGS',
        options: ['5', '4', '3', '2', '1'],
      },
      {
        type: FILTER_TYPES.DATE,
        title: 'DATE',
        options: ['This month', 'Last 30 days', 'Last month', 'Year to date', 'Last 12 months'],
      },
      {
        type: FILTER_TYPES.SINGLE,
        title: 'REVIEW TEXT',
        options: ['Review includes text', 'Review does not include text'],
      }
    );

    this.updateDateFilterDisplay();
  }

  /**
   * Reloads reviews when the selected directory (`reviewType`) changes after initialization.
   * The first change is skipped because `ngOnInit` performs the initial load.
   * @param changes Angular input changes for this component.
   * @returns None.
   */
  ngOnChanges(changes: SimpleChanges): void {
    const reviewTypeChange = changes.reviewType;
    if (!reviewTypeChange || reviewTypeChange.firstChange) {
      return;
    }
    this.resetReviewsPagination();
    this.loadReviews();
  }

  /**
  * @description To hide/display the overviews component.
  * @returns void
  */
  public toggleReviewsCardView(): void {
    this.displayReviewsCard = !this.displayReviewsCard;
  }

  public lazyLoadLocations(event: any): void {
    const nextSortOrder = event.sortField ? `${event.sortField}${event.sortOrder < 0 ? ' DESC' : ''}` : this.sortOrder;
    const isSortChanged = nextSortOrder !== this.sortOrder;
    if (isSortChanged) {
      this.sortOrder = nextSortOrder;
      this.sortCurrentPageReviews(event.sortField, event.sortOrder);
      return;
    }

    const nextOffset = event.first || 0;
    const nextPageIndex = Math.floor(nextOffset / this.pageSize);
    if (nextPageIndex > 0 && !(nextPageIndex in this.reviewPageTokensByIndex)) {
      this.notifyService.error('Unable to load that page yet. Please move page by page.');
      return;
    }

    this.offset = nextOffset;
    this.loadReviews();
  }

  /**
   * Records the chosen sort column/direction and reorders only the reviews currently on the page.
   * No API request is made; pagination and totals are left untouched.
   * @param sortField Review field selected for sorting (e.g. `starRating`).
   * @param sortOrder Sort direction from the table: 1 ascending, -1 descending.
   * @returns None.
   */
  private sortCurrentPageReviews(sortField: string, sortOrder: number): void {
    if (!sortField) {
      return;
    }
    this.activeSortField = sortField;
    this.activeSortOrder = sortOrder;
    this.applySortToCurrentPage();
  }

  /**
   * Reorders the in-memory current-page reviews by the active sort column and direction.
   * No-ops when there is no active column or no loaded reviews.
   * @returns None.
   */
  private applySortToCurrentPage(): void {
    if (!this.activeSortField || !this.reviewData?.length) {
      return;
    }
    const direction = this.activeSortOrder < 0 ? -1 : 1;
    const sortedReviews = [...this.reviewData].sort(
      (first, second) =>
        this.compareReviewValues(
          this.getReviewSortValue(first, this.activeSortField),
          this.getReviewSortValue(second, this.activeSortField)
        ) * direction
    );
    this.reviewData = sortedReviews;
    this.reviewsTableData = sortedReviews;
  }

  /**
   * Resolves the comparable value for a review field, converting date objects to timestamps.
   * @param review Review row to read the sort value from.
   * @param field Review field name being sorted.
   * @returns A timestamp for date fields, otherwise the raw field value, or null when absent.
   */
  private getReviewSortValue(review: IReviewData, field: string): number | string | null {
    const value = review?.[field as keyof IReviewData];
    if (this.dateSortFields.has(field)) {
      return this.reviewDateToTimestamp(value);
    }
    return value as number | string | null;
  }

  /**
   * Converts a mapped review date object into a millisecond timestamp for comparison.
   * @param reviewDate Date object produced by `mapPandioReviewsToTableData` (`{ year, month, day, hour, minute }`).
   * @returns Timestamp in milliseconds, or null when the date is missing/invalid.
   */
  private reviewDateToTimestamp(reviewDate: any): number | null {
    if (!reviewDate || !reviewDate.year) {
      return null;
    }
    const { year, month = 1, day = 1, hour = 0, minute = 0 } = reviewDate;
    return new Date(year, month - 1, day, hour, minute).getTime();
  }

  /**
   * Compares two review sort values with null-safe, numeric-aware ordering.
   * Nulls sort first; numbers compare numerically; everything else compares as locale strings.
   * @param first First value to compare.
   * @param second Second value to compare.
   * @returns Negative when `first` precedes `second`, positive when it follows, 0 when equal.
   */
  private compareReviewValues(
    first: number | string | null,
    second: number | string | null
  ): number {
    if (first == null && second == null) {
      return 0;
    }
    if (first == null) {
      return -1;
    }
    if (second == null) {
      return 1;
    }
    if (typeof first === 'number' && typeof second === 'number') {
      return first - second;
    }
    return String(first).localeCompare(String(second), undefined, { numeric: true, sensitivity: 'base' });
  }

  /**
  * To select a review from the table's list and can be used to download CSV.
  * @param event event is the selected row/review from the table.
  */
  public onRowSelect(event): void {
    // if (this.selectedReviews.length > 0) {
    //   this.actionItems[1].disabled = false;
    //   this.actionItems[0].label = `Selected (${this.selectedReviews.length})`;
    // } else {
    //   this.actionItems[1].disabled = true;
    //   this.actionItems[0].label = `Selected (none)`;
    // }
  }

  /**
   * Updates filter chips and reloads reviews when overlay filter selections change.
   * @param filters Active filter object from table-filter component.
   * @returns None.
   */
  public onChipsRefresh(filters: IFitersObject): void {
    this.filterTableData(filters);
  }

  /**
  * @description To filter table data based on selection.
  * @param event
  * @returns void
  */
  public filterTableData(event): void {
    this.chipsArray = [].concat.apply([], Object.values(event)); // merge all checkbox values into one array
    this.chipsArray = this.chipsArray.filter((e) => e); // remove all possible undefined

    if(!event.hasOwnProperty('DATE')) {
      event = { ...event, DATE: ['DefaultDate'] };
    } else if(event.hasOwnProperty('DATE') && !event['DATE'].length) {
      event = { ...event, DATE: ['DefaultDate'] };
    }

    this.filters = event;
    this.updateDateFilterDisplay(event?.['DATE']?.[0]);
    this.resetReviewsPagination();
    //this.getAllMetricsData();
    this.loadReviews();
  }

  /**
  * @description To download single/multiple/all reviews report.
  * @param table
  */
  public exportAllReviews(table: Table): void {
    this.enableSelectAllReviews = !this.enableSelectAllReviews;
    if (this.enableSelectAllReviews) {
      this.selectedReviews = this.reviewData
      table.exportCSV();
    }
  }

  /**
  * @description To open a new browser tab to enable reviews
  * @param review: IReviewData
  */
  public openExternalResponseLink(review: IReviewData): void {
    window.open(review.attrs?.url, '_blank');
  }

  /**
   * Enqueues a reviews load; only the latest in-flight request may update table state.
   * Older HTTP calls are cancelled via `switchMap` when a newer load is triggered.
   * @returns None.
   */
  loadReviews(): void {
    this.reviewsLoadTrigger$.next();
  }

  /**
   * Subscribes to the reviews load queue and applies only the newest successful response.
   * Superseded requests are unsubscribed so stale responses cannot overwrite current filters.
   * @returns None.
   */
  private initializeReviewsLoadQueue(): void {
    this.reviewsLoadTrigger$
      .pipe(
        switchMap(() => {
          if (!this.accountId || !this.userId) {
            return EMPTY;
          }

          this.loading = true;
          const { timeunit, periods, search, ratings, reviewText, respondedTo } =
            this.addFiltersToReviewData(this.filters);
          const currentPageIndex = Math.floor((this.offset || 0) / this.pageSize);
          const nextPageToken = this.reviewPageTokensByIndex[currentPageIndex] ?? undefined;
          const globalLocationFilters = this.locationFilter?.length
            ? this.locationFilter
            : this.filtersQSFromStore();

          return this.getExportedReport(
            this.accountId,
            this.userId,
            `reviews/list/${this.reviewType}`,
            timeunit,
            periods,
            globalLocationFilters,
            this.pageSize,
            nextPageToken,
            search,
            ratings,
            reviewText,
            respondedTo
          ).pipe(
            map((reviews: any) => ({ reviews, currentPageIndex })),
            catchError((err: Error) => {
              console.warn('Error loading Pandio reviews: %j', err);
              return of({ error: err, currentPageIndex });
            })
          );
        }),
        takeUntil(this.ngSubscribe$)
      )
      .subscribe((result: { reviews?: any; currentPageIndex: number; error?: Error }) => {
        if (result.error) {
          this.reviewData = [];
          this.reviewsTableData = [];
          this.loading = false;
          return;
        }

        const { reviews, currentPageIndex } = result;
        //console.log('reviews in loadReviews: ', reviews);
        const payload = this.parseApiPayload(reviews);
        const parsedReviews = Array.isArray(payload?.reviews) ? payload.reviews : [];
        const apiNextPageToken =
          payload?.next_page_token || payload?.lastEvaluatedKey
            ? String(payload?.next_page_token || payload?.lastEvaluatedKey)
            : null;
        const apiTotalRecordsRetrieved = Number(
          payload?.Total_records_retrieved ??
            payload?.total_records_retrieved ??
            payload?.totalEntries ??
            payload?.total_entries
        );

        this.reviewData = this.mapPandioReviewsToTableData(parsedReviews);
        //console.log('reviewData', this.reviewData);
        this.reviewsTableData = this.reviewData;
        this.applySortToCurrentPage();

        if (apiNextPageToken) {
          this.reviewPageTokensByIndex[currentPageIndex + 1] = apiNextPageToken;
        } else {
          delete this.reviewPageTokensByIndex[currentPageIndex + 1];
        }

        const fallbackTotal = this.offset + this.reviewData.length + (apiNextPageToken ? 1 : 0);
        this.totalReviewsCount = Number.isFinite(apiTotalRecordsRetrieved)
          ? Math.max(apiTotalRecordsRetrieved, fallbackTotal)
          : fallbackTotal;

        this.loading = false;
      });
  }

  /**
   * Configures debounced keyword search and triggers one data reload after 2s of typing inactivity.
   * Emitted values are deduplicated to avoid repeated requests for unchanged input.
   * @returns None.
   */
  private initializeKeywordSearchDebounce(): void {
    this.keywordSearch$
      .pipe(debounceTime(2000), distinctUntilChanged(), takeUntil(this.ngSubscribe$))
      .subscribe(() => {
        this.loadReviews();
      });
  }

  /**
   * Initializes selected account/user streams and returns a one-time context tuple.
   * The fetch is deferred until both streams emit valid values.
   * @returns Observable tuple of selected account and current user.
   */
  private initUserFetchData(): Observable<[IAccount, any]> {
    return combineLatest([
      this.sessionService.getSelectedAccount$().pipe(rxFilter(Boolean), take(1)) as Observable<IAccount>,
      this.sessionService.getCurrentUser$().pipe(rxFilter(Boolean), take(1)),
    ]).pipe(takeUntil(this.ngSubscribe$)) as Observable<[IAccount, any]>;
  }

  /**
   * Converts active table filters into API query params expected by IO reviews endpoints.
   * It derives time window, keyword search, rating list, review text selectors, and response status.
   * @param filters Active filter object from table-filter component.
   * @returns Object containing normalized query params.
   */
  private addFiltersToReviewData(filters = undefined): {
    timeunit: string;
    periods: string;
    search: string;
    ratings: string;
    reviewText: string;
    respondedTo: string;
  } {
    const search = this.keyword;
    const dateFilter = filters?.['DATE']?.[0];
    const ratings = (this.filters?.['RATINGS'] ?? []).join(',');
    const reviewText = this.filters?.['REVIEW TEXT']?.[0];
    const respondedTo = this.filters?.['REVIEWS']?.[0];
    if (!dateFilter) {
      this.periodType = PeriodType.DAY;
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: '30', search, ratings, reviewText, respondedTo };
    }

    if (this.isCustomDateRange(dateFilter)) {
      const [startDate, endDate] = dateFilter.split(' - ');
      const formattedStartDate = startDate.replace(/-/g, '');
      const formattedEndDate = endDate.replace(/-/g, '');
      this.periodType = PeriodType.CUSTOM_DATE;
      return {
        timeunit: PeriodType.CUSTOM_DATE.toLowerCase(),
        periods: `${formattedStartDate}_${formattedEndDate}`,
        search,
        ratings,
        reviewText,
        respondedTo,
      };
    }

    switch (dateFilter) {
      case PeriodText.THIS_MONTH: {
        const today = new Date();
        const daysPassedThisMonth = today.getDate();
        this.periodType = PeriodType.DAY;
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: String(daysPassedThisMonth - 1), search, ratings, reviewText, respondedTo };
      }
      case PeriodText.LAST_30_DAYS: {
        this.periodType = PeriodType.DAY;
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: '30', search, ratings, reviewText, respondedTo };
      }
      case PeriodText.LAST_MONTH: {
        const today = new Date();
        const daysPassedThisMonth = today.getDate();
        this.periodType = PeriodType.DAY;
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: String(daysPassedThisMonth + 31 - 1), search, ratings, reviewText, respondedTo };
      }
      case PeriodText.YEAR_TO_DATE: {
        const today = new Date();
        const startOfYear = new Date(today.getFullYear(), 0, 1);
        const daysPassedThisYear = Math.ceil((today.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24));
        if (daysPassedThisYear > 60) {
          const monthsPassed = today.getMonth();
          this.periodType = PeriodType.MONTH;
          return { timeunit: PeriodType.MONTH.toLowerCase(), periods: String(monthsPassed), search, ratings, reviewText, respondedTo };
        }
        this.periodType = PeriodType.DAY;
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: String(daysPassedThisYear), search, ratings, reviewText, respondedTo };
      }
      case PeriodText.LAST_12_MONTHS: {
        this.periodType = PeriodType.MONTH;
        return { timeunit: PeriodType.MONTH.toLowerCase(), periods: '12', search, ratings, reviewText, respondedTo };
      }
      default:
        return { timeunit: PeriodType.DAY.toLowerCase(), periods: '30', search, ratings, reviewText, respondedTo };
    }
  }

  /**
   * Returns whether the DATE filter value is a custom ISO range (`YYYY-MM-DD - YYYY-MM-DD`).
   * @param dateFilter Raw DATE filter value from table-filter.
   * @returns True when the value matches the custom date range format.
   */
  private isCustomDateRange(dateFilter: string | undefined): boolean {
    return !!dateFilter && this.customDateRangeRegex.test(dateFilter);
  }

  /**
   * Updates the reviews date header to match the active DATE filter.
   * Custom ranges show `Reviews from` with explicit dates; presets show the filter label only.
   * @param dateFilter Optional DATE filter value; falls back to `this.filters.DATE[0]` when omitted.
   * @returns None.
   */
  private updateDateFilterDisplay(dateFilter?: string): void {
    const activeDateFilter = dateFilter ?? this.filters?.['DATE']?.[0];

    if (this.isCustomDateRange(activeDateFilter)) {
      const [start, end] = activeDateFilter.split(' - ');
      this.dateFilterDisplayType = 'custom';
      this.startDate = start;
      this.endDate = end;
      this.dateFilterLabel = '';
      return;
    }

    this.dateFilterDisplayType = 'preset';
    this.startDate = null;
    this.endDate = null;
    this.dateFilterLabel = this.resolvePresetDateFilterLabel(activeDateFilter);
  }

  /**
   * Maps internal/default DATE filter values to user-facing preset labels.
   * @param dateFilter Raw DATE filter value from table-filter.
   * @returns Preset label shown in the reviews date header.
   */
  private resolvePresetDateFilterLabel(dateFilter: string | undefined): string {
    if (!dateFilter || dateFilter === 'DefaultDate') {
      return PeriodText.LAST_30_DAYS;
    }

    return dateFilter;
  }

  /**
   * Builds the location filter query string from selected-locations global state.
   * It favors explicit store codes and otherwise serializes active location facets with the selected operand mode.
   * @returns Query-string fragment for location filters.
   */
  private filtersQSFromStore(): string {
    const state = this.selectedLocationsStore.snapshot;
    if (!state) {
      return 'operand=AND';
    }

    const operand = `operand=${state.mode}`;
    if (state.storeCodes.length) {
      return `${operand}&storecode=${state.storeCodes.map(encodeURIComponent).join(',')}`;
    }

    const qs = this.buildQueryFromFiltersRecord(state.filters);
    return qs ? `${operand}&${qs}` : operand;
  }

  /**
   * Converts persisted location filter state into API query-string parts.
   * @param filters Raw selected-locations filter record.
   * @returns Joined query-string fragment.
   */
  private buildQueryFromFiltersRecord(filters: Record<string, string[] | string>): string {
    const parts: string[] = [];
    Object.entries(filters).forEach(([apiKey, raw]) => {
      const qsKey = this.API_TO_QUERY[apiKey] ?? apiKey;
      const vals = Array.isArray(raw) ? raw : raw ? [String(raw)] : [];
      if (vals.length) {
        parts.push(`${qsKey}=${encodeURIComponent(vals.join(','))}`);
      }
    });
    return parts.join('&');
  }

  /**
   * Builds query string for Pandio reviews endpoint using the same parameter shape as accuracy reports.
   * @param timeunit Aggregation unit expected by API.
   * @param periods Date-range period value.
   * @param filters Serialized global location filters from selected-locations state.
   * @param limit Maximum records requested by API.
   * @param nextPageToken Optional API cursor token for sequential page fetches.
   * @param search Optional keyword search value mapped to `search_term`.
   * @param ratings Optional comma-separated rating values.
   * @param reviewText Optional review text filter label.
   * @param respondedTo Optional response-status filter label from REVIEWS filter.
   * @returns Serialized query string.
   */
  private buildReportQueryString(
    timeunit: string,
    periods: any,
    filters?: string,
    limit: number = 50,
    nextPageToken?: string,
    search?: string,
    ratings?: string,
    reviewText?: string,
    respondedTo?: string
  ): string {
    const queryParams = new URLSearchParams({
      timeunit,
      periods: String(periods),
      limit: String(limit),
    });

    if (filters && filters.length) {
      const filterParams = new URLSearchParams(filters);
      filterParams.forEach((value, key) => queryParams.append(key, value));
    }

    if (search && search.length > 0) {
      queryParams.set('search_term', search);
    }

    if (ratings && ratings.length > 0) {
      queryParams.set('rating', ratings);
    }

    if (reviewText && reviewText.length > 0) {
      queryParams.set('reviewtext', reviewText === 'Review includes text' ? 'true' : 'false');
    }

    if (respondedTo && respondedTo.length > 0) {
      queryParams.set('reply', respondedTo === 'Responded to' ? 'true' : 'false');
    }

    if (nextPageToken) {
      queryParams.set('next_page_token', nextPageToken);
    }
    return queryParams.toString();
  }

  /**
   * Requests Pandio reviews from IO endpoint with JWT authorization.
   * @param accountId Selected account id for JWT payload.
   * @param userId Current user id for JWT payload.
   * @param directoryName Path segment for reviews endpoint.
   * @param timeunit Date aggregation unit.
   * @param periods Date-range periods value.
   * @param filters Serialized global location filters.
   * @param limit Maximum records requested by API.
   * @param nextPageToken Optional API cursor token used for token-based pagination.
   * @param search Optional keyword search value mapped to `search_term`.
   * @param ratings Optional comma-separated rating values.
   * @param reviewText Optional review text filter label.
   * @param respondedTo Optional response-status filter label from REVIEWS filter.
   * @returns Observable response from IO reviews API.
   */
  private getExportedReport(
    accountId: number,
    userId: number,
    directoryName: string,
    timeunit: string,
    periods: any,
    filters?: string,
    limit: number = 50,
    nextPageToken?: string,
    search?: string,
    ratings?: string,
    reviewText?: string,
    respondedTo?: string
  ): Observable<any> {
    const payloadObj = {
      iss: 'https://platform.renderseo.com',
      sub: userId,
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const options = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        Authorization: `${jwtToken}`,
      }),
      responseType: 'text' as any,
    };

    const queryString = this.buildReportQueryString(
      timeunit,
      periods,
      filters,
      limit,
      nextPageToken,
      search,
      ratings,
      reviewText,
      respondedTo
    );
    const url = `https://io.renderseo.com/${directoryName}?${queryString}`;
    //console.log('current url:', url);
    return this.http.get(url, options);
  }

  /**
   * Parses API payloads that may be returned as text or plain objects.
   * Invalid JSON payloads safely degrade to an empty object.
   * @param response Raw API response body.
   * @returns Parsed payload object.
   */
  private parseApiPayload(response: any): any {
    if (!response) {
      return {};
    }
    if (typeof response !== 'string') {
      return response;
    }
    try {
      const normalizedReviews = response.replace(/:\s*NaN(?=\s*[,}\]])/g, ': null');
      return JSON.parse(normalizedReviews);
    } catch {
      return {};
    }
  }

  /**
   * Maps API review rows into table-ready review objects.
   * It normalizes date fields, directory labels, and tooltip fields expected by existing Pandio template bindings.
   * @param parsedReviews API review row collection.
   * @returns Normalized review list for table rendering.
   */
  private mapPandioReviewsToTableData(parsedReviews: any[]): IReviewData[] {
    const buildReviewDate = (value: string | null | undefined): any | null => {
      if (!value) {
        return null;
      }
      const parsedDate = new Date(value.replace(' ', 'T'));
      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }
      const year = parsedDate.getFullYear();
      const month = parsedDate.getMonth() + 1;
      const day = parsedDate.getDate();
      const hour = parsedDate.getHours();
      const minute = parsedDate.getMinutes();
      return {
        _year_: year,
        _month_: month,
        _day_: day,
        year,
        month,
        day,
        hour,
        minute,
      };
    };

    return parsedReviews.map((review: any, index: number) => {
      const reviewCreatedAt = buildReviewDate(review.reviewcreatedat ?? review.date ?? review.ingestedAt);
      const reviewUpdatedAt = buildReviewDate(review.reviewupdatedat ?? review.ingestedAt ?? review.date) ?? reviewCreatedAt;
      const replyUpdatedAt = buildReviewDate(review.responseupdatedat);
      const reviewerComment = review.review ?? review.comment ?? null;
      const tags = String(review.tags || '')
        .split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0);
      const vendorIdent = review.vendorident ?? review.vendorIdent ?? this.inferVendorIdentFromUrl(review.url);

      const mappedReview: IReviewData = {
        _id: index + 1,
        reviewId: review.review_id ?? review.reviewId ?? '',
        reviewIdent: review.review_id ?? review.reviewId ?? '',
        account: '',
        account_id: this.accountId,
        attrs: review.attrs ?? null,
        businessName: review.business_name ?? '',
        addressLines: review.address ? [review.address] : [],
        city: review.city ?? '',
        state: review.state ?? '',
        postalCode: review.postal_code ?? '',
        date_id: 0,
        location_id: Number(review.location_id ?? review.locationId ?? 0),
        replyComment: review.response ?? null,
        replyUpdatedAt,
        reviewCreatedAt,
        reviewUpdatedAt,
        reviewerComment,
        reviewerIsAnonymous: null,
        reviewerName: review.reviewer_name ?? review.reviewerName ?? 'Anonymous',
        reviewerProfileUrl: review.url ?? '',
        starRating: Number(review.rating ?? 0),
        storeCode: review.storecode ?? review.storeCode ?? String(review.location_id ?? review.locationId ?? ''),
        vendorIdent,
        //directory: this.getDirectoryNameFromVendor(vendorIdent),
        tags,
      };

      if (reviewerComment && reviewCreatedAt) {
        mappedReview.reviewTooltip = `<span style="font-style: italic; padding-bottom: 15px">"${reviewerComment}"</span>
                     <p style="text-align: left; margin-top: 12px"><b>Posted by</b> ${mappedReview.reviewerName || 'Unknown'}</p>
                     <p style="text-align: left; margin: 0">on <b>${reviewCreatedAt.day}/${reviewCreatedAt.month}/${reviewCreatedAt.year} ${reviewCreatedAt.hour}:${reviewCreatedAt.minute}</b></p>`;
      }
      return mappedReview;
    });
  }

  /**
   * Maps vendor identifiers into directory labels shown in the Pandio reviews table.
   * Unknown identifiers are returned as empty labels for backward-compatible rendering.
   * @param vendorIdent Vendor identifier from API payload.
   * @returns Display directory label.
   */
  private getDirectoryNameFromVendor(vendorIdent: string): string {
    switch (vendorIdent) {
      case 'tripadvisor.com-lde':
        return 'Tripadvisor';
      case 'zocdoc.com-lde':
        return 'ZocDoc';
      case 'vitals.com-lde':
        return 'Vitals';
      case 'healthgrades.com-lde':
        return 'Healthgrades';
      case 'indeed.com-lde':
        return 'Indeed.com';
      case 'glassdoor.com-lde':
        return 'Glassdoor.com';
      default:
        return '';
    }
  }

  /**
   * Infers vendor identifier from a review URL when the API payload omits vendor keys.
   * Known domains are mapped to existing `*-lde` identifiers used by directory label logic.
   * @param reviewUrl Review source URL from API payload.
   * @returns Vendor identifier string or empty string when domain is unknown.
   */
  private inferVendorIdentFromUrl(reviewUrl: string): string {
    const url = String(reviewUrl || '').toLowerCase();
    if (!url) {
      return '';
    }
    if (url.includes('healthgrades.com')) {
      return 'healthgrades.com-lde';
    }
    if (url.includes('tripadvisor.com')) {
      return 'tripadvisor.com-lde';
    }
    if (url.includes('zocdoc.com')) {
      return 'zocdoc.com-lde';
    }
    if (url.includes('vitals.com')) {
      return 'vitals.com-lde';
    }
    if (url.includes('indeed.com')) {
      return 'indeed.com-lde';
    }
    if (url.includes('glassdoor.com')) {
      return 'glassdoor.com-lde';
    }
    return '';
  }

  /**
   * Resets token-based pagination state and the table paginator back to page zero.
   * It clears the offset and page-token map, and syncs the PrimeNG table's `first`
   * so the paginator UI cannot show a later page while page zero is fetched.
   * No-ops on the table sync until the table view (`reviewTbl`) is available.
   * @returns None.
   */
  private resetReviewsPagination(): void {
    this.offset = 0;
    this.reviewPageTokensByIndex = { 0: null };
    if (this.reviewTbl) {
      this.reviewTbl.first = 0;
    }
  }

  private buildWhereClause(): string[] {
    const filterClauses: string[][] = [];
    const tempFilterArr: string[] = [];
    const isFiltersApplied = this.chipsArray?.length > 0;

    const pushQueriesToMainArray = () => {
      let filterClause: Array<string> = ['-or'];
      filterClause = filterClause.concat(tempFilterArr);
      filterClauses.push(filterClause);
      tempFilterArr.length = 0;
    };

    if (this.chipsArray?.length) {
      for (const [key, value] of Object.entries(this.filters)) {
        if (value.length > 0 && value[0] != undefined) {
          switch (key) {
            case 'DIRECTORIES':
              value.forEach((tag: string) => {
                switch (tag) {
                  case 'Tripadvisor':
                    tempFilterArr.push(`vendorIdent = 'tripadvisor.com-lde'`);
                    break;
                  case 'ZocDoc':
                    tempFilterArr.push(`vendorIdent = 'zocdoc.com-lde'`);
                    break;
                  case 'Vitals':
                    tempFilterArr.push(`vendorIdent = 'vitals.com-lde'`);
                    break;
                  case 'Healthgrades':
                    tempFilterArr.push(`vendorIdent = 'healthgrades.com-lde'`);
                    break;
                  case 'Indeed.com':
                    tempFilterArr.push(`vendorIdent = 'indeed.com-lde'`);
                    break;
                  case 'Glassdoor.com':
                    tempFilterArr.push(`vendorIdent = 'glassdoor.com-lde'`);
                    break;
                  // healthgrades.com-lde and ratemds.com-lde for Healthgrades and RateMDs
                }
              });
              pushQueriesToMainArray();
              break;
            case 'DATE':
              value.forEach((element: string) => {
                this.selectedDateRange = element;
                switch (element) {
                  case 'This month':
                    tempFilterArr.push(`extract(month from r.date) = extract(month from current_date) and extract(year from r.date) = extract(year from current_date)`);
                    break;
                  case 'Last 30 days':
                    tempFilterArr.push(`r.date >= (now() - interval '30 day')`);
                    break;
                  case 'Last month':
                    tempFilterArr.push(
                      `extract(month from r.date) = extract(month from current_date) - 1 and extract(year from r.date) = extract(year from current_date)`
                    );
                    break;
                  case 'Year to date':
                    tempFilterArr.push(`extract(year from r.date) = extract(year from current_date)`);
                    break;
                  case 'Last 12 months':
                    tempFilterArr.push(`r.date > (now() - interval '12 month')`);
                    break;
                  case 'DefaultDate':
                    this.startDate = new Date().toISOString().slice(0, 10);
                    this.endDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().slice(0, 10);
                    tempFilterArr.push(`r.date > (now() - interval '30 day')`);
                    break;
                  default:
                    const dateArray: string[] = element.split(' - ');
                    this.startDate = dateArray[0];
                    this.endDate = dateArray[1];
                    tempFilterArr.push(`reviewCreatedAt >= '${dateArray[0]}' AND reviewCreatedAt <= '${dateArray[1]}'`);
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
            case 'REVIEW TEXT':
              value.forEach((element: string) => {
                switch (element) {
                  case 'Review includes text':
                    tempFilterArr.push(`reviewercomment IS NOT NULL`);
                    break;
                  case 'Review does not include text':
                    tempFilterArr.push(`reviewercomment IS NULL`);
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
            case 'REVIEWS':
              value.forEach((element: string) => {
                element === 'Responded to'
                  ? tempFilterArr.push(`NOT replyComment IS NULL`)
                  : tempFilterArr.push(`replyComment IS NULL`);
              });
              pushQueriesToMainArray();
              break;
          }
        }
      }
    } else {
      this.selectedDateRange = 'DefaultDate';
      this.startDate = new Date().toISOString().slice(0, 10);
      this.endDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().slice(0, 10);
      // Adding default lst 30 days option if no date filter is selected.
      tempFilterArr.push(`r.date >= (now() - interval '30 day')`);
      pushQueriesToMainArray();
      this.startDate = new Date().toISOString().slice(0, 10);
      this.endDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().slice(0, 10);
    }

    if (this.keyword) {
      tempFilterArr.push(`storeCode::text ILIKE '${this.keyword}%'`);
      tempFilterArr.push(`businessName::text ILIKE '${this.keyword}%'`);
      tempFilterArr.push(`reviewerComment::text ILIKE '${this.keyword}%'`);
      tempFilterArr.push(`starRating::text ILIKE '${this.keyword}%'`);
      pushQueriesToMainArray()
    }

    let whereClauseArray: Array<any> = ['-and', "r._status IN ('A', 'UA', 'UP')",];
    whereClauseArray.push(`vendorIdent LIKE '%-lde'`);
    whereClauseArray = whereClauseArray.concat(filterClauses);

    return whereClauseArray;
  }

  /**
   * @description Method to set Direectory name based on the vendorIdent.
   * @param repl: IReviewDataResponse
   */

  public exportFilteredReviews(): void {
    const params = {
      order: this.sortOrder,
      where: this.buildWhereClause()
    };

    this.exportDataToFile.getReviews(params);
  }

  public deleteReview(review): void {
    this.dialogService.open(DeletePopupComponent, {
      data: { ...review, actionType: 'Review', },
      closable: false,
      width: '40%',
    }).onClose.subscribe(res => {
      if(res) {
        this.notifyService.success('Success: Review deleted successfully.');
        this.loadReviews();
      } else {
        this.notifyService.error('Error: Error in deleting the Review. Please try again!');
      }
    });
  }

  /**
   * Queues search input changes for debounced review loading instead of firing requests on every key press.
   * Resets token pagination when the keyword changes so a new search always starts from the first page.
   * The latest `keyword` value is emitted, and pending debounce timers are reset by subsequent keystrokes.
   * @returns None.
   */
  public userSearch(): void {
    const nextKeyword = this.keyword ?? '';
    if (nextKeyword !== this.lastSearchKeyword) {
      this.resetReviewsPagination();
      this.lastSearchKeyword = nextKeyword;
    }
    this.keywordSearch$.next(this.keyword);
  }

  public copyReviewToClipboard(review: IReviewData): void {
    const reviewsObjectCopy = this.reviewsCopyClipboardService.mapReviewDataCopyObject(review);
    const reviewsTextCopy = this.reviewsCopyClipboardService.mapReviewsDataCopyString(reviewsObjectCopy);
    const textArea = document.createElement('textarea');
    textArea.value = reviewsTextCopy;
    navigator.clipboard.writeText(textArea.value);
    this.notifyService.success('Review copied to clipboard');
  }

  ngOnDestroy() {
    this.keywordSearch$.complete();
    this.reviewsLoadTrigger$.complete();
    this.ngSubscribe$.next();
    this.ngSubscribe$.complete();
  }

}
